// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"77ac2758","324":"866a4f78"}[chunkId] + ".chunk.js";
};